import { render, staticRenderFns } from "./PropertyTypesInfoTable.vue?vue&type=template&id=ce95c32c&"
import script from "./PropertyTypesInfoTable.vue?vue&type=script&lang=js&"
export * from "./PropertyTypesInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports